import { Box, styled } from "@mui/material";

/**
 * The card shell, shared by `PublicItem` and `ProductCardSkeleton` (EB-543).
 *
 * A skeleton only earns its keep if it reserves the exact space the real card will take. Sharing
 * these three means the two cannot drift: a padding change in the card is a padding change in its
 * placeholder, rather than a layout shift nobody notices until a slow connection exposes it.
 */

export const CardContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  background: theme.palette.common.white,
  borderRadius: theme.spacing(1),
  boxShadow: theme.shadows[2],
  height: "100%",
  overflow: "hidden",
}));

export const ImageWrapper = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: 8,
});

export const CardContent = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1, 1.5, 1.5),
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(0.5),
  flexGrow: 1,
}));

/** The height `PublicItem` gives its `<img>`; the skeleton block has to match it exactly. */
export const CARD_IMAGE_HEIGHT = 160;
